import { Component } from "@angular/core";
import { CategoryCard } from "../category-card/category-card.component";
import { ProductQueryCategory } from "@models/product.model";

@Component({
    selector: "app-categories-section",
    templateUrl: "./categories-section.component.html",
    styleUrl: "./categories-section.component.scss",
    standalone: false,
})
export class CategoriesSectionComponent {
    categories: CategoryCard[] = [
        {
            title: "Featured",
            description: "Discover our handpicked featured toys that bring creativity and fun to playtime!",
            image: "https://plus.unsplash.com/premium_photo-1661558951515-47f7706fd9c6?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dG95JTIwYmxvY2tzfGVufDB8fDB8fHww", // Replace with your image paths
            target: "/products",
            queryParams: { category: ProductQueryCategory.Featured },
            variant: "feature",
        },
        {
            title: "On Sale",
            description: "Grab exciting deals on top toys – limited time only, don't miss out!",
            image: "https://thumbs.dreamstime.com/b/mega-toy-sale-banner-christmas-special-81645859.jpg",
            target: "/products",
            queryParams: { category: ProductQueryCategory.Sale },
            variant: "sale",
        },
        {
            title: "Design Studio",
            description: "Let your imagination run wild – build, create, and innovate with our design sets.",
            image: "https://images.unsplash.com/photo-1575364289437-fb1479d52732?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8dG95JTIwYmxvY2tzfGVufDB8fDB8fHww",
            target: "/designer",
            variant: "design",
        },
    ];
}
